<template>
  <div>
    <nav class="level">
      <div class="level-item has-text-centered">
        <div>
          <b-table :data="$store.state.evaluation.saleCompGroup.trends">
            <template slot-scope="props">
              <b-table-column
                field="description"
                label="Time Period">
                {{ props.row.description }}
              </b-table-column>
              <b-table-column
                field="avgSalePrice"
                label="Avg Sale $"
                numeric
                sortable>
                 {{ props.row.avgSalePrice | currency(0) }}
              </b-table-column>
              <b-table-column
                field="avgPricePerSqFt"
                label="Avg $ per Sqft"
                numeric
                sortable>
                 {{ props.row.avgPricePerSqFt | currency(0) }}
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
